<template lang="html">
  <div class="adjustment">
    <button
      key="plus"
      aria-label="Plus"
      class="button primary-primary icon-only-with-background plus"
      @mousedown.stop="holdUp"
      @mouseup.stop="stopHold"
      @touchstart.stop="holdUp"
      @touchend.stop="onTouchEnd"
      @mouseleave="stopHold"
      @click.stop="$emit('increaseDuration')"
    >
      <span> </span>
    </button>
    <button key="minus"
      aria-label="Minus"
      class="button primary-primary icon-only-with-background minus"
      @mousedown.stop="holdDown"
      @mouseup.stop="stopHold"
      @touchstart.stop="holdDown"
      @touchend.stop="onTouchEnd"
      @mouseleave="stopHold"
      @click.stop="$emit('decreaseDuration')">
      <span> </span>
    </button>
  </div>
</template>

<script>
export default {
  name: "Adjustment",

  data() {
    return {
      holdButtonTimer: null, // For timer object defining difference between click and hold.,
      lastTouchEnd: null, // To differentiate between hold and click
    };
  },

  methods: {
    // Avoids zooming on double tap, then treats touch event like normal mouseup
    onTouchEnd(e) {
      const elapsed = Date.now() - this.lastTouchEnd;
      this.lastTouchEnd = Date.now();

      if (elapsed < 200) {
        e.preventDefault();
        e.target.click();
      }

      this.stopHold();
    },

    // increase time as long as button is pressed
    holdUp() {
      this.lastTouchEnd = new Date();
      this.holdButtonTimer = setTimeout(() => {
        this.holdButtonTimer = setInterval(() => {
          this.$emit("increaseDuration");
          this.$emit("interactionDetected", "long", true);
        }, 150);
      }, 250);
    },

    // Decrease time as long as button is pressed
    holdDown() {
      this.holdButtonTimer = setTimeout(() => {
        this.holdButtonTimer = setInterval(() => {
          this.$emit("decreaseDuration");
          this.$emit("interactionDetected", "long", true);
        }, 150);
      }, 250);
    },

    // Clear the timeOuts for holding + or -
    stopHold(e) {
      clearTimeout(this.holdButtonTimer);
      this.holdButtonTimer = null;
      clearInterval(this.holdButtonTimer);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../style/abstracts/variables.scss";
@import "../style/abstracts/functions.scss";
@import "../style/abstracts/mixins.scss";

.button {
  &.primary-primary.icon-only-with-background {
    &.plus {
      @include light-round-button-with-icon("Plus");
    }
    &.minus {
      @include light-round-button-with-icon("Minus");
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Adjustment.vue